import { FullUserModel } from 'src/types/user.model';
import * as H from 'history';
import { IncomeSourceModel } from 'src/types/income-source.model';

export class IncomeDrawerViewModel {
    drawerProps: any;
    user: FullUserModel;
    handleBack: () => void;
    history: H.History;
    handleSaveIncome: (user: FullUserModel, incomeSource: IncomeSourceModel) => void;
    handleDeleteIncome: (incomeSource: IncomeSourceModel) => Promise<void>;
    handleReloadUser: () => Promise<void>;
    firstImport: boolean;
    handleAccounts: () => Promise<void>;
    handleClearFirstImport: () => void;
    handleFirstImport: () => void;
    setDrawer: () => void;
}
